import './docx.css';

import mammoth from 'mammoth/mammoth.browser.js';
import { type FC, useEffect, useState } from 'react';

import { Loading } from '@zen/DesignSystem';

interface Props {
  fileUrl: string;
}

const DocxViewer: FC<Props> = ({ fileUrl }) => {
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadDocument = async () => {
      try {
        const response = await fetch(fileUrl);

        if (!response.ok) {
          throw new Error('Failed to fetch document');
        }

        const arrayBuffer = await response.arrayBuffer();
        const result = await mammoth.convertToHtml({ arrayBuffer }, { includeDefaultStyleMap: true });

        const docEl = document.createElement('div');

        docEl.className = 'document-container';
        docEl.innerHTML = result.value;
        setContent(docEl.outerHTML);
      } finally {
        setLoading(false);
      }
    };

    loadDocument();
  }, [fileUrl]);

  return <div id="docx">{loading ? <Loading /> : <div dangerouslySetInnerHTML={{ __html: content }} />}</div>;
};

export default DocxViewer;
